import { HttpApiService } from "@/shared/services/httpApi.service";

import type { PlatformVisitReport } from "./platformActivity";

/** Usage figures never get in the way: a failed report is dropped. */
export const PlatformActivityService = {
  async recordVisits(visits: PlatformVisitReport[]): Promise<void> {
    try {
      await HttpApiService.post("/internal/platform-activity/visits", { visits });
    } catch {
      // Nothing to do: the next report carries the same visit again.
    }
  },
};
